import React, { Component } from 'react';
import classNames from 'classnames';
import * as html from '../../util/html';
import {
    RichEditor,
    FieldHelper
} from '@beisen/chaos-ui';
import RequiredIcon from './Icon/RequiredIcon';
import RightIcon from './Icon/RightIcon';
require('./RichEditor.scss');

import * as uiUtil from '../../util/ui';
import * as helper from '../../util/helper';
import * as richeditorHelper from '../../util/richeditHelper';
import transLoader from '@beisen/i18n-translation-loader';

const defaultTranslation = {
    required: '必填',
    save: '保存'
};

class BSUXRichEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,    //是否显示panel
            value: props.text,
            errorMessage: props.errorMessage && props.errorMessage.message,
            dfsUrl: {}
        };

        this.handleCancel = () => {
            this.setState({ show: false });
        };
        this.handleTouchTap = this.handleTouchTap.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
        this.isTouch = false;
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            required: 'common.required',
            save: 'common.save'
        }), props.translation);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value != this.props.value) {
            this.setState({ value: nextProps.value, errorMessage: nextProps.errorMessage ? nextProps.errorMessage.message : '' });
        }

        this.setState({ errorMessage: nextProps.errorMessage ? nextProps.errorMessage.message : '' });
    }

    handleConfirm(value) {
        value = html.encode(value);
        this.setState({
            show: false,
            value: value
        }, () => {
            let richContent = { text: value, value: value };
            if (this.props.onChange) {
                this.props.onChange(richContent);
            }
        });
    }

    handleTouchTap(e) {
        e.preventDefault();
        if (this.props.onFocus) {
            this.props.onFocus();
        }
        if (this.props.isReadOnly) {
            return false;
        } else {
            this.setState({ show: true });
        }
    }
    componentDidMount() {
      let textAreaVlaue = html.decode(this.state.value || '');
      // 富文本中的图片根据dfs内容发请求返回的地址才是图片的地址
      richeditorHelper.replaceImgUrl(textAreaVlaue, true, (srcUrl, ClientUrl) => {
          let { dfsUrl } = this.state;
          dfsUrl[srcUrl] = ClientUrl;
          this.setState({ dfsUrl: dfsUrl });
      });
    }
    setBoxHeader(cnf) {
        helper.generateHeaderConfig(function(headerConfig, setButton) {
			let config = Object.assign({}, headerConfig);
			//设置左侧按钮
			config = setButton('left', cnf.left_item, config);
			//设置右侧按钮
            config = setButton('right', cnf.right_item, config);
			//设置中间数据
			config.titleItem = cnf.titleItem;
			return config;
		});
    }

    render() {
        //ShowField cls='rich_eidtor_showfield edui-container'
        let { label,isReadOnly,required,desc,customIcon } = this.props;
        const { translation } = this;
        let textAreaVlaue = html.decode(this.state.value || '');
        const { dfsUrl } = this.state;
        if (textAreaVlaue && textAreaVlaue.length > 0 && JSON.stringify(dfsUrl) !== '{}') {
            for (let i in dfsUrl) {
                textAreaVlaue = textAreaVlaue.replace(i, dfsUrl[i]);
            }
        }
        return (
            <div className={classNames('richEdit-container border-1px richEdit', { 'richEdit-readonly': isReadOnly,'error-line': this.state.errorMessage })}
                onTouchTap={this.handleTouchTap}
                ref="richContent">
                <div className={'rich-title'}>
                    <span className={classNames('rich-required',{ 'rich-required-hide': isReadOnly || !required })}><RequiredIcon /></span>
                    <span className='rich-label'>{label}</span>
                    {desc ? <span className="rich-label-icon">{customIcon || <FieldHelper label={label} desc={desc} />}</span> : null}
                </div>
                <span className="rich-edit-arrow"><RightIcon color={isReadOnly ? 'rgba(192,201,209,0.7)' : 'rgb(153,163,173)'} /></span>
                <div className={classNames('edui-container',{ 'edui-container-hide': !this.state.value })}>
                    <div className='edui-editor-body' dangerouslySetInnerHTML={{ __html: html.decode(textAreaVlaue) }} >
                    </div>
                </div>
                {this.state.show ? <RichEditor
                    show={this.state.show}
                    value={textAreaVlaue}
                    title={uiUtil.strEllipsis(this.props.label)}
                    id={this.props.cmp_id + 'rich-editor'}
                    ifHideNav={helper.ifHidePopupNav}
                    setBoxHeader={this.setBoxHeader}
                    clearHeaderConfig={helper.clearHeaderConfig}
                    handleCancel={this.handleCancel}
                    handleConfirm={this.handleConfirm}
                    translation={translation} /> : null}
            </div>
        );
    }
}

export default BSUXRichEditor;



// WEBPACK FOOTER //
// ./src/components/Field_Components/RichEditor/RichEditor.js